module.exports = __webpack_public_path__ + "a3e449b1d57c9e178ca8492764de21bf.png";